<template>
  <div id="app">
    <router-view />
  </div>
</template>

<!--
<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-paper.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
-->

<style src="./vendor/styles/main.scss" lang="scss"></style>


<style src="./style.scss" lang="scss"></style>

<style>
@import '../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../node_modules/@syncfusion/ej2-calendars/styles/material.css';
@import '../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
@import '../node_modules/@syncfusion/ej2-vue-grids/styles/material.css';
@import "../node_modules/@syncfusion/ej2-filemanager/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-richtexteditor/styles/material.css";
</style>

<script>
import Vue from 'vue';

Vue.prototype.$bus = new Vue();


export default {
  name: 'app',
  metaInfo: {
    title: 'Index',
    titleTemplate: '%s - Cognatis'
  },
  methods: {
    ImportLogi() {
      //let recaptchaScript = document.createElement('script')
      //recaptchaScript.setAttribute('src', 'http://10.100.100.116/ticket/rdTemplate/rdEmbedApi/rdEmbed.js')
      //document.head.appendChild(recaptchaScript)
      //console.log("Inject logi, done!")
    },
  },
  data: () => ({

  }),
  created() {

    console.info('')
    console.log('### NetTool Pro ###')
    console.log('Version:', process.env.VUE_APP_GIT_VERSION);
    console.log('Commit:', process.env.VUE_APP_COMMIT);
    console.log('Build date:', process.env.VUE_APP_BUILD_DATE);
    console.log(`Environment: ${process.env.NODE_ENV}`);
    console.log('###')
    this.ImportLogi()

  },
  updated() {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1)
  }
}
</script>
